//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ContactForm from '@/components/Banners/ContactFields/ContactForm.vue';


export default {
  name: 'GeneralDentBanner',
  props: {
    titleId: {
      type: String,
    }
  },
  components: {
    ContactForm,
  },
  data() {
    return {
      userData: {
        name: '',
        phone: '',
        email: '',
        countryOfResidence: '',
      },
      message: null,
      generalService: null,
      turkeyVisitPlan: null,
      previousTreatment: null,
      budget: null,
      contactPreference: null,

      options: {
        loop: false,
        lazy: true,

        slidesPerView: 1,
        spaceBetween: 10,
        allowTouchMove: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },

      buttonsSwiperOptions: {
        loop: true,
        slidesPerView: 4,
        spaceBetween: 10,
        allowTouchMove: true,
        breakpoints: {
          1200: {
            slidesPerView: 4,
          },
          992: {
            slidesPerView: 4,
          },
          768: {
            slidesPerView: 3,
          },
          576: {
            slidesPerView: 2,
          },
          380: {
            slidesPerView: 2
          }

        }

      },
    };
  },

  computed: {
    phoneValidatedComputed() {
      return this.phoneValidated;
    },
    submitButtonDisabled() {
      return this.phoneValidated === false || this.name === '' || this.email === '' || this.emailValidated === false || this.countryOfResidence === null;
    },
    swiperOptions() {
      return this.options = {
        ...this.options,
        navigation: {
          nextEl: '.next-generaldentbanner-' + this.titleId,
          prevEl: '.prev-generaldentbanner-' + this.titleId,
        }
      }
    }
  },

  mounted() {
    const nextButton = document.querySelectorAll('.update-message-' + this.titleId);

    nextButton.forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const value = item.getAttribute('data-value');
        const key = item.getAttribute('data-key');
        this[key] = value;
        console.log(this[key]);
        this.updateMessage(key + ': ' + value);
      });
    });

  },
  methods: {

    updateUserData(data) {
      this.userData = { ...data }
    },
    updateMessage(value) {
      // Clear message for each new selection to avoid appending
      if (this.message === null) {
        this.message = value + ` `;
      } else {
        this.message += value + ` `;
      }
      console.log(this.message);
    },
    validatePhoneNumber(phoneNumber) {
      const phoneRegex = /^(\+\d{1,2})?\d{8,}$/;
      console.log(phoneNumber, phoneRegex.test(phoneNumber));
      return this.phoneValidated = phoneRegex.test(phoneNumber);
    },

    validateEmail() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return this.emailValidated = emailRegex.test(this.email);
    },

    async contactFormSend() {
      // Construct message from all collected data points
      this.message = `General Service: ${this.generalService}, Turkey Visit Plan: ${this.turkeyVisitPlan}, Previous Treatment: ${this.previousTreatment}, Budget: ${this.budget}, Contact Preference: ${this.contactPreference}`;


      if (!(this.validatePhoneNumber(this.userData.phone))) {
        this.$toast.error(this.$i18n.t('contactForm.wrongPhoneFormat'))
        return
      }
      //if there is files selected
      try {
        let fd = new FormData();

        fd.append("name", this.userData.name);
        fd.append("phone", this.userData.phone);
        fd.append("email", this.userData.email);
        fd.append("message", this.message);
        fd.append("fullsrc", `https://www.ilajak.com${this.$route.fullPath}`);

        this.$toast.info(this.$t("contactForm.sending"), {
          duration: 1000,
        });

        console.log('tost');
        await this.$api.contactFormSend(fd).then((resp) => {
          console.log(resp, 'asdasdasdasd', 'resp.status', resp.status === 200);

          if (resp.status === 200 || resp.status === 204) {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({ event: "form_submitted" });
            // console.log("we are here " + resp.status)

            document.querySelector(".next-generaldentbanner-" + this.titleId).click();
            console.log("we are here " + resp.status);
            this.$toast.success(resp.message);
            this.form.phone = null;
            this.form.message = null;

          }
        });
      } catch (e) {
        // this.$toast.error(e.response.data.message);
      }

      // if no files selected

    }
  },

};
